var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "XLS",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Path",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-xls",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3937",
    "data-name": "Path 3937",
    d: "M9.445,5H19.713a1.071,1.071,0,0,1,1.071,1.071V23.214a1.071,1.071,0,0,1-1.071,1.071H6.141A1.071,1.071,0,0,1,5.07,23.214V9.361A1.071,1.071,0,0,1,5.4,8.6L8.688,5.3A1.071,1.071,0,0,1,9.445,5Z",
    transform: "translate(-4.688 -4.643)",
    fill: "rgba(159,168,218,0.4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_553",
    "data-name": "Group 553",
    transform: "translate(0.332 0.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3938",
    "data-name": "Path 3938",
    d: "M4.98,25l-.05-3.379L20.459,6.09l.236,8.193L9.98,25Z",
    transform: "translate(-4.93 -5.69)",
    fill: "#eceef8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3939",
    "data-name": "Path 3939",
    d: "M4.93,17.188,17.148,4.97l2.054.089L4.98,19.277Z",
    transform: "translate(-4.93 -4.97)",
    fill: "#eceef8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3940",
    "data-name": "Path 3940",
    d: "M4.93,15.084,14.98,5.03h1.071L4.93,16.155Z",
    transform: "translate(-4.93 -5.009)",
    fill: "#eceef8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_552",
    "data-name": "Group 552",
    transform: "translate(1.811 2.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3941",
    "data-name": "Path 3941",
    d: "M37.324,13.03l.439.807.811.443-.811.443-.439.807-.443-.807-.811-.443.811-.443Z",
    transform: "translate(-26.427 -12.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3942",
    "data-name": "Path 3942",
    d: "M22.934,11.03l.307.561.557.3-.557.3-.307.561-.3-.561-.561-.3.561-.3Z",
    transform: "translate(-17.427 -11.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3943",
    "data-name": "Path 3943",
    d: "M9.659,42.03l.207.382.382.207-.382.207-.207.382-.207-.382-.382-.207.382-.207Z",
    transform: "translate(-9.07 -30.959)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3944",
    "data-name": "Path 3944",
    d: "M9.356,5.03V9.316H5.07Z",
    transform: "translate(-4.688 -4.662)",
    fill: "#9fa8da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3980",
    "data-name": "Path 3980",
    d: "M0,0H15.714V7.857H0Z",
    transform: "translate(3.954 6.796)",
    fill: "#9fa8da"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_551",
    "data-name": "Group 551",
    transform: "translate(1.429 17.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3945",
    "data-name": "Path 3945",
    d: "M8.357,52A.357.357,0,0,0,8,52.357v.714a.357.357,0,1,0,.714,0v-.714A.357.357,0,0,0,8.357,52Z",
    transform: "translate(-8 -52)",
    fill: "#7481c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3946",
    "data-name": "Path 3946",
    d: "M13.357,52a.357.357,0,0,0-.357.357v.714a.357.357,0,1,0,.714,0v-.714A.357.357,0,0,0,13.357,52Z",
    transform: "translate(-11.214 -52)",
    fill: "#7481c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3947",
    "data-name": "Path 3947",
    d: "M18.357,53.429a.357.357,0,0,0,.357-.357v-.714a.357.357,0,1,0-.714,0v.714A.357.357,0,0,0,18.357,53.429Z",
    transform: "translate(-14.429 -52)",
    fill: "#7481c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3948",
    "data-name": "Path 3948",
    d: "M23.357,53.429a.357.357,0,0,0,.357-.357v-.714a.357.357,0,1,0-.714,0v.714A.357.357,0,0,0,23.357,53.429Z",
    transform: "translate(-17.643 -52)",
    fill: "#7481c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3949",
    "data-name": "Path 3949",
    d: "M28.357,53.429a.357.357,0,0,0,.357-.357v-.714a.357.357,0,1,0-.714,0v.714A.357.357,0,0,0,28.357,53.429Z",
    transform: "translate(-20.857 -52)",
    fill: "#7481c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3950",
    "data-name": "Path 3950",
    d: "M33.357,53.429a.357.357,0,0,0,.357-.357v-.714a.357.357,0,1,0-.714,0v.714A.357.357,0,0,0,33.357,53.429Z",
    transform: "translate(-24.071 -52)",
    fill: "#7481c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3951",
    "data-name": "Path 3951",
    d: "M38.357,53.429a.357.357,0,0,0,.357-.357v-.714a.357.357,0,1,0-.714,0v.714A.357.357,0,0,0,38.357,53.429Z",
    transform: "translate(-27.286 -52)",
    fill: "#7481c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3952",
    "data-name": "Path 3952",
    d: "M43.357,53.429a.357.357,0,0,0,.357-.357v-.714a.357.357,0,1,0-.714,0v.714A.357.357,0,0,0,43.357,53.429Z",
    transform: "translate(-30.5 -52)",
    fill: "#7481c9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3953",
    "data-name": "Path 3953",
    d: "M23.286,10.429H20.429V5.071A1.071,1.071,0,0,0,19.357,4H8.879a1.786,1.786,0,0,0-1.264.521L4.521,7.614A1.786,1.786,0,0,0,4,8.879v14.05A1.071,1.071,0,0,0,5.071,24H19.357a1.071,1.071,0,0,0,1.071-1.071V19h2.857A.714.714,0,0,0,24,18.286V11.143A.714.714,0,0,0,23.286,10.429ZM8.121,5.029a1.072,1.072,0,0,1,.164-.136V7.929a.357.357,0,0,1-.357.357H4.893a1.021,1.021,0,0,1,.136-.164Zm11.593,17.9a.357.357,0,0,1-.357.357H5.071a.357.357,0,0,1-.357-.357V9H7.929A1.071,1.071,0,0,0,9,7.929V4.714H19.357a.357.357,0,0,1,.357.357v5.357H8.286a.714.714,0,0,0-.714.714v7.143A.714.714,0,0,0,8.286,19H19.714Zm3.571-4.643h-15V11.143h15Z",
    transform: "translate(-4 -4)",
    fill: "#7481c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3954",
    "data-name": "Path 3954",
    d: "M37.143,31.571H35.714V28.357a.357.357,0,0,0-.714,0v3.571a.357.357,0,0,0,.357.357h1.786a.357.357,0,1,0,0-.714Z",
    transform: "translate(-23.929 -19.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3955",
    "data-name": "Path 3955",
    d: "M26.724,28.048a.357.357,0,0,0-.489.121l-.764,1.279-.764-1.275a.357.357,0,0,0-.611.357l.957,1.611-.961,1.6a.357.357,0,0,0,.611.357l.768-1.268.764,1.275a.357.357,0,1,0,.611-.357l-.957-1.611.961-1.6A.357.357,0,0,0,26.724,28.048Z",
    transform: "translate(-16.899 -19.427)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3956",
    "data-name": "Path 3956",
    d: "M44.071,28A1.071,1.071,0,0,0,43,29.071v.357A1.071,1.071,0,0,0,44.071,30.5h.714a.357.357,0,0,1,.357.357v.357a.357.357,0,0,1-.357.357h-.714a.357.357,0,0,1-.357-.357.357.357,0,0,0-.714,0,1.071,1.071,0,0,0,1.071,1.071h.714a1.071,1.071,0,0,0,1.071-1.071v-.357a1.071,1.071,0,0,0-1.071-1.071h-.714a.357.357,0,0,1-.357-.357v-.357a.357.357,0,0,1,.357-.357h.714a.357.357,0,0,1,.357.357.357.357,0,0,0,.714,0A1.071,1.071,0,0,0,44.786,28Z",
    transform: "translate(-29.071 -19.429)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.901d996b826f5939ac98d2ae905d578f.svg";
export { ForwardRef as ReactComponent };